import React from 'react';
import classNames from 'classnames';
import styles from './AdminCheckbox.module.css';

const AdminCheckbox = ({
  name,
  checked,
  onChange,
  label,
  style,
  value,
  propRef,
  colorHexcode,
  id,
  disabled,
}) => (
  <label
    htmlFor={id || name}
    className={classNames(styles.checkbox, { [styles.disabled]: disabled })}
    style={style}
    disabled={disabled}
  >
    <input
      type="checkbox"
      name={name}
      checked={checked}
      value={value}
      onChange={onChange}
      ref={propRef}
      id={id || name}
      disabled={disabled}
    />
    <span className={styles.checkmark}>
      <i className="fa fa-check" aria-hidden="true" />
    </span>
    {label}
    {colorHexcode && (
      <div
        className={styles.colorSquare}
        style={{ backgroundColor: `#${colorHexcode}` }}
      />
    )}
  </label>
);

export default AdminCheckbox;
